<template>
  <div class="data_body">
    <div style="width: 100%; height: 100%;align-items: center;justify-content: center;">
      <!-- <div id="cateRank" class="echart" style="width: 100%; height: 100%"></div> -->
      <highcharts :options="data" style="width: 100%; height: 95%;"></highcharts>
    </div>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import HighCharts from 'highcharts'
//和弦图的引入依赖
import HC_sankey from 'highcharts/modules/sankey';
import dependencywheel from 'highcharts/modules/dependency-wheel';
import { data } from 'jquery';
HC_sankey(HighCharts);
dependencywheel(HighCharts);

export default {
  components: {
    highcharts: Chart,
  },
  props: {
    data:{
			type:Object,
			default:()=>{}
		}
  },
  data() {
    return {
      chartObj: null,
    };
  },
  methods: {
    setChart() {
      // 雷达图显示的标签
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        this.chartObj = Highcharts.chart('cateRank',this.data);
      });
			window.addEventListener("resize", () => {
					this.chartObj.resize();
      });
    },
  },
  mounted() {
    this.$nextTick(()=>{
      this.setChart();
    })

  },
};
</script>

<style scoped>
.data_body {
  height: 100%;
  /* display: flex; */
  position: relative;
  border-radius: 5px;
  /* border: 1px solid #eee; */
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  width: 95%;
  /* background: #fff; */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/testPerson/portrait/chordDiagramView.vue